import common from './en.json';
import payDetails from '../modules/pay-details/locales/en.json';
import payroll from '../modules/payroll/locales/en.json';

const combined = {
  ...common,
  ...payDetails,
  ...payroll,
};

export default combined;
